<template>
	<v-col class="ma-0 pa-0 pt-5 pb-5" cols="11">
		<v-row class="ma-0 pa-0 mb-10" align="center" justify="space-between">
			<v-row class="ma-0 pa-0 pl-2" align="center">
				{{t('theConditions')}}:
				<v-btn width="auto" height="auto" class="ma-0 pa-2 ml-5" 
					id="back_clean_btn" elevation="0" @click="filterClose2">
					<v-row class="ma-0 pa-0" align="center" style="color:white;">
						<v-img max-height="1rem" max-width="1rem" class="ma-0 pa-0 mr-2"
							:class="{'rotate_icon': filterOn }"
							src="@/assets/images/plus_white.png"></v-img>
							{{t('filtering')}}
					</v-row>
				</v-btn>
			</v-row>
			<v-col class="ma-0 pa-0" cols="auto">
				<v-btn id="grey_btn" class="ml-2" @click="filterReset">
					{{t('reset')}}
				</v-btn>
			</v-col>
		</v-row>
		<v-row class="ma-0 pa-0 pb-2" justify="center">
			<v-col class="ma-0 pa-0" cols="12" id="filterBox">
				<v-col class="ma-0 pa-0" cols="12">
					<v-row class="ma-0 pa-0">
						<v-col class="ma-0 pa-2 pr-4" cols="2" align="right"
							style="border-right: 3px solid #4A4A4A;">
							{{t('cctvCamera')}}
						</v-col>
						<v-col class="ma-0 pa-0" cols="10">
							<v-row class="ma-0 pa-2 pt-0 pl-4" align="center">
								<v-col class="ma-0 pa-0" cols="4">
									<v-row class="ma-0 pa-0" align="center">
										<input id="check_box" type="checkbox" v-model="filterOptions.motion" />
										<v-col class="ma-0 pa-0 ml-3" cols="auto">{{t('motionDetect')}}</v-col>
									</v-row>
								</v-col>
								<v-col class="ma-0 pa-0" cols="8">
									<v-row class="ma-0 pa-0" align="center" justify="space-between">
										<v-col class="ma-0 pa-0" cols="5.5">
											<CustomDatePicker :viewTextField="true" :initDate="true"
												:reset="resetValue"
												@resultDate="motionDetectBeginDateFunc" />
										</v-col>
										<v-col class="ma-0 pa-0 pl-1 pr-1" cols="auto" align="center">~</v-col>
										<v-col class="ma-0 pa-0" cols="5.5">
											<CustomDatePicker :viewTextField="true" :initDate="false"
												:reset="resetValue"
												@resultDate="motionDetectEndingDateFunc" />
										</v-col>
									</v-row>
								</v-col>
							</v-row>
							<v-row class="ma-0 pa-2 pt-0 pl-4" align="center">
								<v-col class="ma-0 pa-0" cols="4">
									<v-row class="ma-0 pa-0" align="center">
										<input id="check_box" type="checkbox" v-model="filterOptions.sound" />
										<v-col class="ma-0 pa-0 ml-3" cols="auto">{{t('soundDetect')}}</v-col>
									</v-row>
								</v-col>
								<v-col class="ma-0 pa-0" cols="8">
									<v-row class="ma-0 pa-0" align="center" justify="space-between">
										<v-col class="ma-0 pa-0" cols="5.5">
											<CustomDatePicker :viewTextField="true" :initDate="true"
												:reset="resetValue"
												@resultDate="soundDetectBeginDateFunc" />
										</v-col>
										<v-col class="ma-0 pa-0 pl-1 pr-1" cols="auto" align="center">~</v-col>
										<v-col class="ma-0 pa-0" cols="5.5">
											<CustomDatePicker :viewTextField="true" :initDate="false"
												:reset="resetValue"
												@resultDate="soundDetectEndingDateFunc" />
										</v-col>
									</v-row>
								</v-col>
							</v-row>
							<!-- <v-row class="ma-0 pa-2 pt-0 pl-4" align="center">
								<v-col class="ma-0 pa-0" cols="4">
									<v-row class="ma-0 pa-0" align="center">
										<input id="check_box" type="checkbox" />
										<v-col class="ma-0 pa-0 ml-3" cols="auto">{{t('peopleDetect')}}</v-col>
									</v-row>
								</v-col>
								<v-col class="ma-0 pa-0" cols="8">
									<v-btn width="7rem" height="auto" class="ma-0 pa-2" 
										id="grey_btn" elevation="0">
										{{t('peopleDetect')}}
									</v-btn>
								</v-col>
							</v-row> -->
						</v-col>
					</v-row>
					<!-- <v-row class="ma-0 pa-0 mt-5">
						<v-col class="ma-0 pa-2 pr-4" cols="2"  align="right"
							style="border-right: 3px solid #4A4A4A;">{{t('analyze')}}</v-col>
						<v-col class="ma-0 pa-0" cols="10">
							<v-row class="ma-0 pa-2 pt-0 pl-4" align="center">
								<v-col class="ma-0 pa-0 pl-6" cols="4">{{t('selectDuration')}}</v-col>
								<v-col class="ma-0 pa-0" cols="8">
									<v-row class="ma-0 pa-0" align="center" justify="space-between">
										<v-col class="ma-0 pa-0" cols="5.5">
											<CustomDatePicker :viewTextField="true" :time="false"
												@resultDate="beginDateFunc" />
										</v-col>
										<v-col class="ma-0 pa-0 pl-1 pr-1" cols="auto" align="center">~</v-col>
										<v-col class="ma-0 pa-0" cols="5.5">
											<CustomDatePicker :viewTextField="true" :time="false"
												@resultDate="endingDateFunc" />
										</v-col>
									</v-row>
								</v-col>
							</v-row>
							<v-row class="ma-0 pa-2 pt-0 pl-4" align="center">
								<v-col class="ma-0 pa-0 pl-6" cols="4">{{''}}</v-col>
								<v-col class="ma-0 pa-0" cols="8">
									<v-radio-group v-model="selectedAnylizeRadio"
										class="ma-0 pa-0" dense hide-details>
										<template v-for="item in anylizeRadioGroup">
											<v-radio :value="item.value" :key="item.value" dark
												color="#1976d2">
												<template v-slot:label>
													<v-col class="ma-0 pa-0 pt-2 pb-2" cols="auto"
														style="color:white;font-size:0.9rem;">
														{{item.label}}
													</v-col>
												</template>
											</v-radio>
										</template>
									</v-radio-group>
								</v-col>
							</v-row>
							<v-row class="ma-0 pa-2 pt-0 pl-4" align="center">
								<v-col class="ma-0 pa-0" cols="4">
									<v-row class="ma-0 pa-0" align="center">
										<input id="check_box" type="checkbox" />
										<v-col class="ma-0 pa-0 ml-3" cols="auto">{{t('visitorCount')}}</v-col>
									</v-row>
								</v-col>
								<v-col class="ma-0 pa-0" cols="8">
									<v-row class="ma-0 pa-0" align="center">
										<v-col class="ma-0 pa-0" cols="auto" style="width:8rem;">
											<v-select background-color="#272727" dark
												v-model="selectedVisitantStartOption"
	  										:items="visitantStartOptionList" dense hide-details outlined 
												item-text="label" item-value="value"
											></v-select>
										</v-col>
										<v-col class="ma-0 pa-0 pl-3 pr-3" cols="auto">~</v-col>
										<v-col class="ma-0 pa-0" cols="auto" style="width:8rem;">
											<v-select background-color="#272727" dark
												v-model="selectedVisitantEndOption"
	  										:items="visitantEndOptionList" dense hide-details outlined 
												item-text="label" item-value="value"
											></v-select>
										</v-col>
									</v-row>
								</v-col>
							</v-row>
							<v-row class="ma-0 pa-2 pt-0 pl-4" align="center">
								<v-col class="ma-0 pa-0" cols="4">
									<v-row class="ma-0 pa-0" align="center">
										<input id="check_box" type="checkbox" />
										<v-col class="ma-0 pa-0 ml-3" cols="auto">{{t('genderRatio')}}</v-col>
									</v-row>
								</v-col>
								<v-col class="ma-0 pa-0" cols="8">
									<v-row class="ma-0 pa-0" align="center">
										<v-col class="ma-0 pa-0" cols="2">{{t('man') + ' : ' + manPercent/10 }}</v-col>
										<v-col class="ma-0 pa-0 pl-1 pr-1" cols="7" align-self="center">
											<v-slider class="slider_slot" step="10" v-model="manPercent"
												dense hide-details dark></v-slider>
										</v-col>
										<v-col class="ma-0 pa-0" cols="2">{{t('weman') + ' : ' + womanPercent}}</v-col>
									</v-row>
								</v-col>
							</v-row>
							<v-row class="ma-0 pa-2 pt-0 pl-4" align="center">
								<v-col class="ma-0 pa-0" cols="4">
									<v-row class="ma-0 pa-0" align="center">
										<input id="check_box" type="checkbox" />
										<v-col class="ma-0 pa-0 ml-3" cols="auto">{{t('repeaterRatio')}}</v-col>
									</v-row>
								</v-col>
								<v-col class="ma-0 pa-0" cols="8">
									<v-col class="ma-0 pa-0" cols="auto" style="width:8rem;">
										<v-select background-color="#272727" dark
											v-model="selectedReVisitantOption"
	  									:items="reVisitantOptionList" dense hide-details outlined 
											item-text="label" item-value="value"
										></v-select>
									</v-col>
								</v-col>
							</v-row>
							<v-row class="ma-0 pa-2 pt-0 pl-4 pb-3" align="center">
								<v-col class="ma-0 pa-0" cols="4">
									<v-row class="ma-0 pa-0" align="center">
										<input id="check_box" type="checkbox" />
										<v-col class="ma-0 pa-0 ml-3" cols="auto">{{t('sales')}}</v-col>
									</v-row>
								</v-col>
								<v-col class="ma-0 pa-0" cols="8">
									<v-row class="ma-0 pa-0" align="center">
										<v-col class="ma-0 pa-0" cols="auto" style="width:8rem;">
											<v-select background-color="#272727" dark
												v-model="selectedSalesStartOption"
	  										:items="salesStartOptionList" dense hide-details outlined 
												item-text="label" item-value="value"
											></v-select>
										</v-col>
										<v-col class="ma-0 pa-0 pl-3 pr-3" cols="auto">~</v-col>
										<v-col class="ma-0 pa-0" cols="auto" style="width:8rem;">
											<v-select background-color="#272727" dark
												v-model="selectedSalesEndOption"
	  										:items="salesEndOptionList" dense hide-details outlined 
												item-text="label" item-value="value"
											></v-select>
										</v-col>
									</v-row>
								</v-col>
							</v-row>
						</v-col>
					</v-row> -->
				</v-col>
			</v-col>
		</v-row>
		<v-row class="ma-0 pa-0 pt-2 pb-2" align="center" justify="center">
			<v-btn class="ma-0 pa-0" width="8rem" height="2rem" id="grey_btn" 
				@click="filterClose">{{t('back')}}</v-btn>
			<v-btn class="blue_btn ma-0 pa-0 ml-2" width="8rem" height="2rem" id="blue_btn5" 
				@click="filterClose">{{t('add')}}</v-btn>
		</v-row>
	</v-col>
</template>

<script>
import mixin from '@/mixin';
import { VISTANT_START_OPTION, VISITANT_END_OPTION, REVISITANT_OPTION,
	SALES_START_OPTION, SALES_END_OPTION } from '@/constants';
import CustomDatePicker from '@/components/DatePicker.vue';
export default {
	props: {
		filterOn: { type: Boolean, default: false },
	},
	components: {
		CustomDatePicker
	},
	mixins: [mixin.common],
	data: () => ({
		filterOptions: {
			motion: false,
			sound: false,
		},
		motionDetectBeginDate: '',
		motionDetectEndingDate: '',
		soundDetectBeginDate: '',
		soundDetectEndingDate: '',
		resetValue: '',
		running: false,
		manPercent: 0,
		womanPercent: 0,
		selectedAnylizeRadio: 0,
		visitantStartOptionList: VISTANT_START_OPTION,
		selectedVisitantStartOption: '10人',
		visitantEndOptionList: VISITANT_END_OPTION,
		selectedVisitantEndOption: '100人',
		reVisitantOptionList: REVISITANT_OPTION,
		selectedReVisitantOption: '50',
    salesStartOptionList: SALES_START_OPTION,
		selectedSalesStartOption: '100,000',
		salesEndOptionList: SALES_END_OPTION,
		selectedSalesEndOption: '500,000',
	}),
	computed: {
		anylizeRadioGroup() {
			return [
				{ label: this.$i18n.t('lang.common.requirementsOnAllDates'), value: 0 },
				{ label: this.$i18n.t('lang.common.conditionsEvenForOneDay'), value: 1 },
				{ label: this.$i18n.t('lang.common.conditionsInTotalValue'), value: 2 },
			];
		}
	},
	watch: {
		manPercent: function(item) {
			this.womanPercent = 10 - item / 10;
		},
		'filterOptions': {
			deep: true,
			handler(val, oldVal) {
				this.filterResultEmit();
			}
		},
		motionDetectBeginDate: function() {
			this.filterResultEmit();
		},
		motionDetectEndingDate: function() {
			this.filterResultEmit();
		},
		soundDetectBeginDate: function() {
			this.filterResultEmit();
		},
		soundDetectEndingDate: function() {
			this.filterResultEmit();
		},
	},
	mounted() {
		
	},
	methods: {
		filterReset() {
			this.filterOptions.motion = false;
			this.filterOptions.sound = false;
      this.resetValue = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString();
		},
		motionDetectBeginDateFunc(date) {
			this.motionDetectBeginDate = date;
		},
		motionDetectEndingDateFunc(date) {
			this.motionDetectEndingDate = date;
		},
		soundDetectBeginDateFunc(date) {
			this.soundDetectBeginDate = date;
		},
		soundDetectEndingDateFunc(date) {
			this.soundDetectEndingDate = date;
		},
		filterClose() {
			this.$emit('close', false);
		},
		filterClose2() {
			let status = this.filterOn;
			this.$emit('close2', !status);
		},
		getAreaStoresData(motionBegin, motionEnd, soundBegin, soundEnd) {
			this.$emit('getArea', {
				motionBegin, motionEnd, soundBegin, soundEnd
			});
		},
		filterResultEmit() {
			let motionBegin = '';
			let motionEnd = '';
			let soundBegin = '';
			let soundEnd = '';
			if(this.filterOptions.motion) {
				motionBegin = this.motionDetectBeginDate;
				motionEnd = this.motionDetectEndingDate;
			}
			if(this.filterOptions.sound) {
				soundBegin = this.soundDetectBeginDate;
				soundEnd = this.soundDetectEndingDate;
			}
			this.$emit('getArea', {
				motionBegin, motionEnd, soundBegin, soundEnd
			});
		},
	}
}
</script>

<style lang="scss" scoped>
.blue_btn {
	background-color: #008DD0 !important;
	color: white;
	border-radius: 4px;
	min-width: 1rem;
}
.rotate_icon{
  transform: rotate(45deg);
}
#filterBox {
	min-height: 350px;
  overflow: auto;
  text-align: left;
  color: white;
	&::-webkit-scrollbar {
		width: 3px;
	}
	&::-webkit-scrollbar-thumb {
		background-color: white;
	}
	&::-webkit-scrollbar-track {
		background-color: #4A4A4A;
	}
}
.v-list{
  background: #171921;
	border: 1px solid #4A4A4A;
}
::v-deep {
  .v-list-item{
    min-height: 0;
    color: white !important;
  }
  .v-list-item__content{
    color: white;
    padding: 5px 0;
  }
	// Select Box Height 설정
	.v-text-field--outlined > .v-input__control > .v-input__slot {
		min-height: 30px !important;
	}
	.v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control {
		height: 35px;
	}
}
</style>